export { GradientText } from './GradientText';
